import { Signals } from './Signals';

export const Notifications = {
  Signals,
};
